/** Trim and strip optional surrounding quotes from env values (common in .env files). */
export function trimEnv(value: string | undefined): string | undefined {
  let v = value?.trim();
  if (!v) {
    return undefined;
  }
  if (
    (v.startsWith('"') && v.endsWith('"')) ||
    (v.startsWith("'") && v.endsWith("'"))
  ) {
    v = v.slice(1, -1).trim();
  }
  return v || undefined;
}
